import MaterialTable, { MTableToolbar } from '@material-table/core';
import AddIcon from '@mui/icons-material/Add';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import makeStyles from '@mui/styles/makeStyles';
import { AppConfig } from 'AppConfig';
import axios from 'axios';
import { confirmDialog } from 'common/ComfirmationDialog';
import * as Constant from 'common/Constant';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'store/store';
import useUpdateEffect from 'utils/useUpdateEffect';
import * as MDActions from '../../common/actions/CommonActions';
import * as DateUtil from '../../util/Dateutil';
import * as Actions from './actions/PlanDesignDataAction';
import VisionClone from './components/visionClone';
import VisionPlanNetwork from './components/visionPlanNetwork';
import VisionPlanNetworkDetailDialog from './components/visionPlanNetworkDetailDialog';
import PlanDesignDataDetailDialog from './detailDialog';

const useStyles = makeStyles(() => ({
  planYearSelect: {
    marginLeft: '1rem',
    minWidth: 150
  }
}));

const VisionPlan = ({ tenantId }) => {
  const ALL_YEARS = 'All';

  const styles = useStyles();

  const tableRef = useRef();

  const [open, setOpen] = useState(false);
  const [cloneData, setCloneData] = useState({});
  const [detailpanelState, setdetailpanelState] = useState({});
  const [interalDetailPanelState, setInteralDetailPanelState] = useState({});
  const [detailOpen, setDetailOpen] = useState(false);
  const [networkDetailOpen, setNetworkDetailOpen] = useState(false);
  const [networkDetail, setNetworkDetail] = useState({});
  const [existingNetworks, setExistingNetworks] = useState([]);
  const [pageSize, setPageSize] = useState(Constant.DEFAULT_SELECT_PAGE_SIZE);
  const [planYears, setPlanYears] = useState([ALL_YEARS]);

  const allNetworkTypes = useSelector(
    (state) => state.MD.mdCommon.allNetworkTypes
  );
  const shouldRefresh = useSelector(
    (state) => state.MD.plandDesignData.shouldRefresh
  );
  const totalPlanYears = useSelector(
    (state) => state.MD.mdCommon.allPlanYearsForTenant
  );

  const isAllSelected = planYears.length === 1 && planYears[0] == ALL_YEARS;

  const handleClone = (rowData) => {
    setCloneData({ ...rowData, type: Constant.PLAN_DESIGN_DATA_TYPE.VISION });
    setOpen(true);
  };

  const handleDetailClone = (rowData) => {
    setCloneData({
      ...rowData,
      planFunding: rowData.planFunding || 'Self Funded' // Default to 'Self Funded' if not present
    });
    setDetailOpen(true);
  };

  const handleNetworkOpen = (data) => {
    setNetworkDetail(data);
    setNetworkDetailOpen(true);
  };

  const handleClose = (data) => {
    if (data) {
      store.dispatch(
        Actions.cloneVision({
          targetId: data.targetId,
          annualPlanId: data.ahpmId,
          startDate: data.planStartDate,
          endDate: data.planEndDate,
          planName: data.planName
        })
      );

      setOpen(false);
    } else {
      setOpen(false);
    }
  };

  const handleDetailClose = (data) => {
    if (data) {
      store.dispatch(
        Actions.save({
          ...data,
          tenantId: tenantId
        })
      );
    }

    setDetailOpen(false);
  };

  const handleNetworkDetailClose = (data) => {
    if (data) {
      store.dispatch(
        Actions.saveVisionNetwork({
          ...data,
          tenantId: tenantId
        })
      );
    }

    setNetworkDetailOpen(false);
  };

  const deletePlan = (rowData) => {
    confirmDialog(() => store.dispatch(Actions.deletePDA(rowData.id)));
  };

  const refresh = () => {
    refreshNetworkTypes();
    tableRef.current.onQueryChange();
  };

  //function to remembe which detail is expend
  const handleDetailExpend = (item, expend) => {
    setInteralDetailPanelState({
      ...interalDetailPanelState,
      [item.planId]: {
        [item.id]: expend
      }
    });
  };

  const handlePlanYearSelection = (event) => {
    const inputVal = event.target.value;
    if (inputVal.length === 0 || inputVal[inputVal.length - 1] === ALL_YEARS) {
      setPlanYears([ALL_YEARS]);
    } else {
      setPlanYears(inputVal.filter((yr) => yr !== ALL_YEARS));
    }
  };

  useEffect(() => {
    store.dispatch(MDActions.fetchAllPlanYears(tenantId));
    refreshNetworkTypes();
    store.dispatch(MDActions.getAllElectionTiers());
  }, [tenantId]);

  useUpdateEffect(() => {
    if (tableRef.current) {
      tableRef.current.onQueryChange();
    }
  }, [tenantId, planYears]);

  const refreshNetworkTypes = () => {
    store.dispatch(MDActions.getAllNetworkTypes());
  };

  useEffect(() => {
    if (
      tableRef.current &&
      shouldRefresh !== Actions.SHOULD_REFRESH_INIT_VALUE
    ) {
      refreshNetworkTypes();
      tableRef.current.onQueryChange();
    }
  }, [shouldRefresh]);

  return (
    <>
      <MaterialTable
        title=""
        tableRef={tableRef}
        columns={[
          { title: 'Plan Year', field: 'planYearName' },
          { title: 'Plan Funding', field: 'planFunding' },
          { title: 'Plan Name', field: 'planName' },
          {
            title: 'Start Date',
            field: 'planStartDate',
            render: (rowData) => DateUtil.DEFAULT_FORMAT(rowData.planStartDate)
          },
          {
            title: 'End Date',
            field: 'planEndDate',
            render: (rowData) => DateUtil.DEFAULT_FORMAT(rowData.planEndDate)
          },
          {
            title: 'TPA Plan Number',
            field: 'planNumber',
            cellStyle: {
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              maxWidth: 500
            }
          }
        ]}
        data={(query) =>
          new Promise((resolve, reject) => {
            //remember the existing state before refresh
            let pState = {};

            tableRef.current.state.data.map((data) => {
              pState[data.id] = data.tableData.showDetailPanel;
            });
            setdetailpanelState(pState);

            //end of remember state
            axios
              .post(AppConfig.API_BASE_URL + `v2/plan/vision/search`, {
                tenantId: tenantId,
                years: ALL_YEARS === planYears[0] ? [] : planYears,
                page: query.page,
                size: query.pageSize,
                direction: query.orderDirection
                  ? query.orderDirection.toUpperCase()
                  : Constant.DIRECTION_DESC,
                sortProperty: query.orderBy
                  ? query.orderBy.field
                  : 'planYearName'
              })
              .then((m) => {
                let data = m.data;
                data.content.forEach((item) => {
                  if (pState[item.id]) {
                    if (item.networkValues) {
                      item.networkValues.forEach((mi) => {
                        const found = interalDetailPanelState[item.id];
                        if (found) {
                          mi.default_open = found[mi.id];
                        }
                      });
                    }
                    item.tableData = {
                      showDetailPanel: tableRef.current.props.detailPanel
                    };
                  }
                });
                resolve({
                  data: data.content,
                  page: data.number,
                  size: data.szie,
                  totalCount: data.totalElements
                });
              })
              .catch((err) => {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 0
                });
                console.log('error' + err);
              });
          })
        }
        onChangeRowsPerPage={setPageSize}
        options={{
          selection: false,
          exportButton: {
            csv: true,
            pdf: false
          },
          actionsColumnIndex: -1,
          search: false,
          pageSizeOptions: Constant.DEFAULT_SEARCH_PAGE_SIZE,
          pageSize
        }}
        actions={[
          (rowData) => ({
            icon: () => <PlaylistAddIcon />,
            tooltip: !(
              rowData &&
              rowData.visionNetworkValue &&
              rowData.visionNetworkValue.id > 0
            )
              ? 'Add Network'
              : 'N/A',
            disabled:
              rowData &&
              rowData.visionNetworkValue &&
              rowData.visionNetworkValue.id > 0,
            onClick: (_, rowData) => {
              handleNetworkOpen({ planId: rowData.id });
            }
          }),
          {
            icon: () => <EditIcon />,
            tooltip: 'Edit',
            onClick: (_, rowData) => {
              handleDetailClone(rowData);
            }
          },
          {
            icon: () => <AddToPhotosIcon />,
            tooltip: 'Clone',
            onClick: (event, rowData) => {
              handleClone(rowData);
            }
          },
          {
            icon: () => <DeleteIcon />,
            tooltip: 'Delete User',
            onClick: (_, rowData) => deletePlan(rowData)
          },
          {
            icon: () => <RefreshIcon />,
            tooltip: 'Refresh Data',
            onClick: () => {
              refresh();
            },
            isFreeAction: true
          },
          {
            icon: () => <AddIcon />,
            tooltip: 'Add',
            isFreeAction: true,
            onClick: () => {
              handleDetailClone({
                planStartDate: null,
                planEndDate: null,
                type: Constant.PLAN_DESIGN_DATA_TYPE.VISION
              });
            }
          }
        ]}
        onRowClick={(event, rowData, togglePanel) => togglePanel()}
        detailPanel={(rowData) => {
          return (
            <>
              {rowData.rowData.visionNetworkValue &&
              rowData.rowData.visionNetworkValue.id > 0 ? (
                <Box ml={8} mr={8} mt={2} mb={2}>
                  <VisionPlanNetwork
                    item={rowData.rowData.visionNetworkValue}
                    handleEdit={(data) => handleNetworkOpen(data)}
                    handleExpend={(data, expend) =>
                      handleDetailExpend(data, expend)
                    }
                  />
                </Box>
              ) : null}
            </>
          );
        }}
        components={{
          OverlayLoading: () => <div />,
          Toolbar: (props) => (
            <>
              <MTableToolbar {...props} />
              <Box sx={{ backgroundColor: '#fff', px: 2, pt: 2, pb: 1 }}>
              <FormControl className={styles.planYearSelect} size="medium">
                <InputLabel id="label_planYear">Plan Year:</InputLabel>
                <Select
                  multiple
                  id="input_planYear"
                  key="input_planYear"
                  onChange={handlePlanYearSelection}
                  value={planYears}
                  renderValue={(planYears) => planYears.join(', ')}>
                  <MenuItem value={ALL_YEARS}>
                    <ListItemIcon>
                      <Checkbox checked={isAllSelected} />
                    </ListItemIcon>
                    <ListItemText primary={ALL_YEARS} />
                  </MenuItem>
                  {totalPlanYears &&
                    Array.isArray(totalPlanYears) &&
                    totalPlanYears.map((item) => (
                      <MenuItem value={item.planYearName}>
                        <ListItemIcon>
                          <Checkbox
                            checked={
                              planYears.indexOf(item.planYearName) > -1 ||
                              isAllSelected
                            }
                          />
                        </ListItemIcon>
                        <ListItemText primary={item.planYearName} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              </Box>
            </>
          )
        }}
      />
      <VisionClone
        open={open}
        onSubmit={handleClone}
        onClose={handleClose}
        tenantId={tenantId}
        target={cloneData}
      />
      <PlanDesignDataDetailDialog
        open={detailOpen}
        onClose={handleDetailClose}
        tenantId={tenantId}
        target={cloneData}
        category={Constant.PLAN_DESIGN_DATA_TYPE.VISION}
      />
      <VisionPlanNetworkDetailDialog
        open={networkDetailOpen}
        onClose={handleNetworkDetailClose}
        tenantId={tenantId}
        target={networkDetail}
      />
    </>
  );
};

export default VisionPlan;
